<template>
  <div id="app">
    <div class="god">
      <div class="godcon">
        <!-- 未登录 -->
        <div class="not-login" v-if="!isLogin">
            <Login></Login>
        </div>
        <!-- 已登录 -->
        <div v-else class="yes-login">
          <ul class="type">
            <li v-for="(item, index) in godTypeArr" :key="index" @click="showCom(item.com)">{{item.name}}</li>
            <li @click="logout">登出</li>
          </ul>
          <div class="content">
            <component :ParentData="$data" :is="activeCom"></component>
          </div>
        </div>
      </div>
    </div>
    <div class="header">
      <div class="left">
        <div class="search" :class="{baidu: searchTypeIndex === 1}">
          <input v-model="searchWord" type="text" placeholder="请输入关键词" @dblclick="clearInput('searchWord')" @keydown="keydownWord" maxlength="300">
          <a href="javascript:;" target="_self" @click="goSearch">{{searchType[searchTypeIndex].name}}</a>
          <div class="suggest" v-if="suggestData.length">
            <ul>
              <li v-for="(item, index) in suggestData" :key="index" :class="{active: suggestActive.q === item.q}" @click="selectSuggest(item.q)">{{item.q}}</li>
            </ul>
          </div>
        </div>
        <a class="switch" :class="{animate: searchTypeIndex === 1}" href="javascript:;" target="_self" @click="switchSearch"></a>
        <div class="filter">
          <input v-model="filterWord" type="text" placeholder="请输入过滤词" @dblclick="clearInput('filterWord')" maxlength="300">
        </div>
      </div>
      <div class="right" @click="showGod">网址导航</div>
    </div>
    <div class="container">
      <div class="type">
        <ul>
          <li :class="{active: activeType.id === item.id}" v-for="(item, index) in typeData" :key="item.id" :style="`background: ${item.background}`" @click="changeType(item)">{{item.name}}</li>
        </ul>
      </div>
      <div class="content" :style="`background-color:${activeType.background}`">
        <div>
          <ul>
            <li v-for="(item, index) in listDataFilter" :key="index"><a :href="item.url" target="_blank">{{item.name}}</a></li>
          </ul>
        </div>
      </div>
    </div>
    <div class="footer">
      <p>截止目前本系统已收集{{typeData.length || 0}}个目录，共计{{listData.length || 0}}个网址</p>
      <p>Copyright © 2013 - {{year}} Guo Zhenxing. All Rights Reserved.</p>
    </div>

    <!-- 右键 -->
    <div class="mouse-right" v-if="mouseShow" :style="`left: ${mouseClientX}px; top: ${mouseClientY}px;`">
      <a href="javascript:;" target="_self" @click="copyFun('name')" class="copyBtn">复制名称</a>
      <a href="javascript:;" target="_self" @click="copyFun('url')" class="copyBtn">复制链接</a>
      <a v-if="isLogin" href="javascript:;" target="_self" @click="editFun">编辑</a>
      <a v-if="isLogin" href="javascript:;" target="_self" @click="deleteFun">删除</a>
    </div>
    <!-- 编辑 -->
    <el-dialog title="编辑" :visible.sync="editDialogVisible" width="550px" @closed="closedEditDialog" :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form ref="editForm" :model="editForm" :rules="editRules" label-width="80px">
        <el-form-item label="分类" prop="type">
          <el-select v-model="editForm.type" placeholder="请选择">
            <el-option
              v-for="item in typeData"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="名称" prop="name">
          <el-input v-model="editForm.name"></el-input>
        </el-form-item>
        <el-form-item label="链接" prop="newUrl">
          <el-input v-model="editForm.newUrl"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="small" @click="onEditCancel">取消</el-button>
          <el-button size="small" type="primary" @click="onEditSubmit">提交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
  import $ from 'jquery';
  import 'jquery.nicescroll';
  import ClipboardJS from 'clipboard';

  import Login from '@/components/Login'
  import AddLink from '@/components/tools/AddLink';
  import NTP from '@/components/tools/NTP';
  import DNS from '@/components/tools/DNS';
  import Random from '@/components/tools/Random';
  import QRCode from '@/components/tools/QRCode';
  import Agent from '@/components/tools/Agent';
  import {getList, getType, getUserInfo, addLink, delLink, logout} from '@/api/app';

  let isShowGod = false, eleScroll, suggestAjaxNum = 0;

  export default {
    name: 'app',
    data() {
      return {
        isLogin: false,
        editDialogVisible: false,
        mouseClientX: 0,
        mouseClientY: 0,
        mouseShow: false,
        mouseData: {},
        activeCom: 'AddLink',
        year: new Date().getFullYear(),
        suggestActive: '',
        searchWord: '',
        filterWord: '',
        activeType: {},
        listData: [],
        typeData: [],
        isSendSuggest: true,
        suggestIndex: -1,
        suggestData: [],
        searchTypeIndex: 0,
        searchType: [
          {
            name: 'Google',
            url: 'https://www.google.com/search?q='
          },
          {
            name: 'Baidu',
            url: 'https://www.baidu.com/s?wd='
          }
        ],
        godTypeArr: [
          {
            name: '添加链接',
            com: 'AddLink'
          },
          {
            name: '阿里NTP',
            com: 'NTP'
          },
          {
            name: '公共DNS',
            com: 'DNS'
          },
          {
            name: '随机数',
            com: 'Random'
          },
          {
            name: '二维码',
            com: 'QRCode'
          },
          {
            name: '代理访问',
            com: 'Agent'
          }
        ],
        editForm: {
          name: '',
          newUrl: '',
          url: '',
          type: ''
        },
        editRules: {
          name: [
            { required: true, message: '请填写名称', trigger: 'blur'}
          ],
          newUrl: [
            { required: true, message: '请填写链接', trigger: 'blur'}
          ],
          type: [
            { required: true, message: '请选择分类', trigger: 'change'}
          ]
        }
      }
    },
    components: {Login, AddLink, NTP, DNS, Random, QRCode, Agent},
    created() {
      this.getUserInfo();
      this.getType();
      this.getList();
      this.mouseFun();
    },
    methods: {
      getUserInfo() {
        getUserInfo().then(res => {
          this.isLogin = res.status || false;
        })
      },
      getList() {
        getList().then(res => {
          this.listData = res.data || [];
          this.initScroll();
        })
      },
      getType() {
        getType().then(res => {
          this.typeData = res.data || [];
          this.activeType = this.typeData[0]
        })
      },
      initScroll() {
        this.$nextTick(function () {
          eleScroll = $(".container .content > div");
          if (eleScroll.getNiceScroll().length) {
            eleScroll.getNiceScroll().resize();
          } else {
            eleScroll.niceScroll({
              cursorcolor: '#9e9e9e',
              cursoropacitymax: 0.8,
              cursorborderradius: '3px',
              cursorwidth: '3px',
              autohidemode: false,
              cursorborder: '1px solid #9e9e9e'
            });
          }
        });
      },
      changeType(item) {
        this.filterWord = '';
        this.activeType = item;
        this.$nextTick(function () {
          if (!eleScroll) {
            return;
          }
          eleScroll.getNiceScroll().resize();
        })
      },
      clearInput(name) {
        this[name] = '';
      },
      keydownWord(e) {
        let index;
        if (e.key === 'Enter') {
          e.preventDefault();
          this.goSearch();
        }
        if (e.key === 'Tab') {
          e.preventDefault();
          this.switchSearch();
        }
        if (e.key === 'ArrowDown') {
          if(!this.suggestData.length){
            return;
          }
          index = ++this.suggestIndex;
          if(index > this.suggestData.length - 1){
            this.suggestIndex = 0;
            index = 0;
          }
          this.suggestActive = this.suggestData[index];
          this.isSendSuggest = false;
          this.searchWord = this.suggestActive.q;
          setTimeout(() => {
            this.isSendSuggest = true;
          })
        }
        if (e.key === 'ArrowUp') {
          if(!this.suggestData.length){
            return;
          }
          index = --this.suggestIndex;
          if (index < 0) {
            this.suggestIndex = this.suggestData.length - 1;
            index = this.suggestData.length - 1;
          }
          this.suggestActive = this.suggestData[index];
          this.isSendSuggest = false;
          this.searchWord = this.suggestActive.q;
          setTimeout(() => {
            this.isSendSuggest = true;
          })
        }
      },
      switchSearch() {
        this.searchTypeIndex = this.searchTypeIndex === 0 ? 1 : 0
      },
      goSearch() {
        this.suggestData = [];
        window.open(this.searchType[this.searchTypeIndex].url+this.searchWord);
      },
      showCom(com) {
        this.activeCom = com;
      },
      showGod() {
        if (!eleScroll) {
          return;
        }
        eleScroll.getNiceScroll().hide();
        isShowGod = !isShowGod;
        if (isShowGod) {
          $('.god').show()
        }
        const height = $('.god .godcon').outerHeight();
        $('.god').css({
          height: isShowGod ? height : 0,
          borderColor: isShowGod? '#ADADAD' : '#FFFFFF'
        });
        setTimeout(() => {
          eleScroll.getNiceScroll().resize();
          eleScroll.getNiceScroll().show();
          if (!isShowGod) {
            $('.god').hide()
          }
        }, 201)
      },
      mouseFun() {
        $(document).on({
          click: () => {
            this.mouseShow = false;
            this.mouseData = {};
            this.suggestData = [];
          }
        });
        $('html').on('contextmenu', '.container .content ul li a', (e) => {
          e.preventDefault();
          const index = $(e.toElement.parentNode).index();
          this.mouseData = this.listDataFilter[index];
          this.mouseClientX = e.clientX + 1;
          this.mouseClientY = e.clientY + 1;
          this.mouseShow = true;
        });
      },
      copyFun(type) {
        const typeName = type === 'name' ? '名称' : '链接';
        const clipboard = new ClipboardJS('.copyBtn', {
          text: () => {
            return this.mouseData[type];
          }
        });
        clipboard.on('success', () => {
          this.$message.success(`${typeName}复制成功`);
        });
        setTimeout(() => {
          clipboard.destroy();
        })
      },
      editFun() {
        this.editDialogVisible = true;
        this.editForm.name = this.mouseData.name;
        this.editForm.url = this.mouseData.url;
        this.editForm.newUrl = this.mouseData.url;
        this.editForm.type = this.mouseData.type;
      },
      deleteFun() {
        delLink({
          url: this.mouseData.url,
        }).then(res => {
          if(res.status){
            this.$message.success(`删除成功`);
            this.getList();
          }
        })
      },
      onEditCancel() {
        this.editDialogVisible = false;
      },
      onEditSubmit() {
        this.$refs['editForm'].validate(valid => {
          if (valid) {
            addLink({
              type: this.editForm.type,
              name: this.editForm.name,
              url: this.editForm.url,
              newUrl: this.editForm.newUrl
            }).then(res => {
              if (res.status) {
                this.$message.success(`编辑成功`);
                this.editDialogVisible = false;
                this.getList();
              } else {
                this.$message.error(res.msg);
              }
            })
          }
        })
      },
      closedEditDialog() {
        this.$refs['editForm'].resetFields();
      },
      getSuggest(word, num) {
        $.ajax({
          dataType: 'jsonp',
          url: `https://www.baidu.com/sugrec?prod=pc&bs=5a1Fazu8AA54nxGko9WTAnF6hhy&wd=${word}`,
          success: (res) => {
            if (suggestAjaxNum!==num) {
              return;
            }
            this.suggestData = res && res.g || [];
            this.suggestIndex = -1;
          }
        });
      },
      selectSuggest(word) {
        this.isSendSuggest = false;
        this.searchWord = word;
        this.goSearch();
        this.suggestData = [];
        setTimeout(() => {
          this.isSendSuggest = true;
        })
      },
      logout() {
        logout().then(res=>{
          history.go(0)
        })
      }
    },
    watch: {
      searchWord: function (newVal) {
        if (this.isSendSuggest && newVal) {
          ++suggestAjaxNum;
          this.getSuggest(newVal, suggestAjaxNum)
        } else if (this.isSendSuggest) {
          this.suggestData = []
        }
      },
      listDataFilter: {
        handler: function () {
          this.initScroll();
        },
        deep: true
      }
    },
    computed: {
      listDataFilter() {
        return (this.listData).filter(item => {
          if (this.filterWord) {
            const reg = new RegExp(this.filterWord, 'ig');
            return reg.test(item.name) || reg.test(item.url) || reg.test(item.pinyin)
          } else {
            return item.type === this.activeType.id
          }
        });
      }
    }
  }
</script>

<style lang="scss">
  * { box-sizing: border-box;}
  html, body { padding: 0; margin: 0;}
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif; -webkit-font-smoothing: antialiased; -moz-osx-font-smoothing: grayscale; color: #2c3e50;
    ul { list-style: none; padding: 0; margin: 0;}
    $width: 100vw; $maxWidth: 1200px;
    .god {
      width: $width; max-width: $maxWidth; margin: 0 auto; border: 1px dashed #FFFFFF; border-top: none; border-radius: 3px; border-top-left-radius: 0; border-top-right-radius: 0; overflow: hidden; height: 0; transition: all 200ms ease-in-out; display: none;
      .godcon {padding: 10px;}
      a { text-decoration: none; color: #FFFFFF; background: #00bcd4; display: inline-block; padding: 0 8px; height: 25px; line-height: 25px; border-radius: 3px; font-size: 14px;}
      .not-login {
        text-align: center;
      }
      .yes-login {
        ul.type {
          display: flex; margin-bottom: 10px;
          li {
            background: #00bcd4; height: 30px; color: #FFFFFF; line-height: 30px; padding: 0 8px; border-radius: 3px; user-select: none; cursor: pointer; margin-right: 10px; font-size: 14px;
            &:last-child { margin-right: 0; background: #C65A5E; margin-left: auto;}
          }
        }
        .content {
          margin: 20px 0; display: flex; align-items: center; justify-content: center;
        }
      }
    }
    .header {
      height: 60px; display: flex; align-items: center; justify-content: space-between; width: $width; max-width: $maxWidth; margin: 0 auto;
      .left {
        display: flex; align-items: center;
        $val: 35px;
        .switch {
          width: 30px; height: $val; background: url("data:image/png;base64,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") center center no-repeat; display: inline-block; margin-right: 30px; margin-left: 5px; background-size: 100% auto; transition: all 200ms ease-in-out;
          &.animate { transform: rotate(360deg);}
        }
        input {
          border-radius: $val; height: $val; border: 3px solid #78C2AE; padding: 0 10px; outline: none; width: 150px;
        }
        .search {
          position: relative;
          input { width: 300px; border-color: #78C2AE; transition: all 200ms ease-in-out; padding-right: 71px; border-right: none;}
          a { background: #78C2AE; color: #FFFFFF; width: 70px; text-align: center; text-decoration: none; height: 100%; position: absolute; right: 0; top: 0; border-top-right-radius: $val; border-bottom-right-radius: $val; display: flex; align-items: center; justify-content: center; font-size: 14px; outline: none; transition: all 200ms ease-in-out;}
          .suggest {
            position: absolute; left: 10px; top: 32px; width: calc(100% - 20px); border: 3px solid #7BC2AE; background: #FFFFFF; border-bottom-left-radius: 7px; border-bottom-right-radius: 7px;
            ul {
              li {
                padding: 2px 5px; text-overflow: ellipsis; overflow: hidden; word-break: keep-all;; white-space: nowrap; font-size: 14px; cursor: pointer;
                &.active, &:hover { background: #7BC2AE; color: #FFFFFF;}
              }
            }
          }
          &.baidu {
            input { border-color: #2CACF7;}
            a { background: #2CACF7;}
          }
        }
      }
      .right { font-size: 40px; font-weight: bolder; color: #18A554; user-select: none; cursor: pointer;}
    }
    .container {
      display: flex; width: $width; max-width: $maxWidth; margin: 0 auto; height: calc(100vh - 60px - 67px);  overflow: hidden; min-height: 300px; user-select: none; max-height: 600px;
      .type {
        width: 100px; height: 100%; overflow: hidden; padding-right: 10px;
        ul {
          display: flex; flex-direction: column; justify-content: center; height: 100%; width: 100%;
          li {
            text-align: center; cursor: pointer; color: #FFFFFF; flex: 1; display: flex; align-items: center; justify-content: center; width: 100%; transition: width 300ms ease-in-out;
            &.active, &:hover { width: calc(100% + 10px);}
          }
        }
      }
      .content {
        flex: 1; width: 0; height: 100%; transition: background-color 300ms ease-in-out;
        & > div { height: 100%; width: 100%;}
        ul {
          display: grid; grid-template-columns: repeat(auto-fill, minmax(170px, 1fr)); grid-gap: 25px; padding: 25px;
          li {
            a {
              text-decoration: none; color: #FFFFFF; outline: none;
              &:hover { color: #000000;}
            }
          }
        }
      }
    }
    .footer {
      line-height: 16px; text-align: center; padding: 15px 0; font-size: 12px; color: #A9A9A9; width: $width; max-width: $maxWidth; margin: 0 auto; user-select: none;
      p {
        margin: 0; margin-bottom: 5px;
        &:last-child { margin-bottom: 0;}
      }
    }
    .mouse-right {
      background: #FFFFFF; width: 200px; border: 1px solid #DADCE0; padding: 5px 0; position: fixed; left: 50%; top: 50%;
      a {
        display: block; height: 24px; line-height: 24px; color: #000000; text-decoration: none; font-size: 12px; padding: 0 25px;
        &:hover { background: #DADCE0;}
      }
    }
    @media (max-width: 700px) {
      font-size: 12px;
      .header {
        .left {
          .search, .switch { display: none;}
          .filter {
            width: 100vw !important;
            input { width: 100vw !important;}
          }
        }
        .right { display: none;}
      }
      .container {
        max-height: 90vh !important;
        .type {
          width: 75px !important; padding-right: 0 !important;
          ul {
            li {
              width: 70px !important;
            }
          }
        }
        .content {
          ul {
            grid-gap: 15px; padding: 10px;
            grid-template-columns: repeat(auto-fill, minmax(60px, 1fr));
            li { word-wrap: break-word;}
          }
        }
      }
      .footer { display: none;}
    }
  }
</style>
